import React, { useRef } from "react";
import { Input, Typography } from "antd";
import styles from "./custom-otp-input.module.css";

const { Text } = Typography;

const CustomOtpInput = ({
  id,
  label = "OTP",
  value = "",
  onChange,
  otpLength = 6,
  labelColor = "#000",
  disabled = false,
  status,
  errorMessage,
  size = "large",
  showRequired = false,
}) => {
  const inputsRef = useRef([]);

  const handleOtpChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, "");
    const otpArray = value ? value.split("") : Array(otpLength).fill("");
    otpArray[index] = val ? val[val.length - 1] : "";
    const newOtp = otpArray.join("");
    onChange({ target: { value: newOtp } });

    if (val && index < otpLength - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("Text").replace(/\D/g, "");
    if (!pasteData) return;

    const otpArray = Array(otpLength).fill("");
    for (let i = 0; i < otpLength; i++) {
      otpArray[i] = pasteData[i] || "";
      if (otpArray[i] && inputsRef.current[i]) {
        inputsRef.current[i].value = otpArray[i];
      }
    }

    onChange({ target: { value: otpArray.join("") } });

    const firstEmptyIndex = otpArray.findIndex((c) => c === "");
    if (firstEmptyIndex >= 0 && inputsRef.current[firstEmptyIndex]) {
      inputsRef.current[firstEmptyIndex].focus();
    }
  };

  return (
    <div className={styles.wrapper}>
      {label && (
        <div style={{ marginBottom: 8, fontWeight: 400, color: labelColor }}>
          {label}
          {showRequired && <span style={{ color: "red" }}> *</span>}
        </div>
      )}

      <div className={styles.otpWrapper}>
        {Array.from({ length: otpLength }).map((_, i) => (
          <Input
            key={i}
            id={`${id}-${i}`}
            ref={(el) => (inputsRef.current[i] = el)}
            maxLength={1}
            value={value?.[i] || ""}
            onChange={(e) => handleOtpChange(e, i)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            onPaste={handlePaste}
            size={size}
            disabled={disabled}
            status={status}
            className={styles.otpInput}
            inputMode="numeric"
            pattern="\d*"
          />
        ))}
      </div>

      {errorMessage && (
        <Text type="danger" style={{ marginTop: 5, display: "block" }}>
          {errorMessage}
        </Text>
      )}
    </div>
  );
};

export default CustomOtpInput;
